import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../contexts/LanguageContext";
import { foodBg } from "../../../assets/images";

export function UnauthorizedView() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900/90">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${foodBg})` }}
      />
      <motion.div
        className="relative z-10 text-center max-w-sm p-8 bg-white dark:bg-white/10 backdrop-blur-xl rounded-2xl border border-ink-900/10 dark:border-white/20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-xl font-bold text-ink-900 dark:text-white mb-3">
          {t("unauthorizedAccess")}
        </h1>
        <p className="text-ink-600 dark:text-white/80 mb-6 text-sm">{t("mustBeLoggedInToAdd")}</p>
        <button
          onClick={() => navigate("/auth")}
          className="px-6 py-2.5 bg-orange-500 hover:bg-orange-600 text-white rounded-xl font-medium"
        >
          {t("login")}
        </button>
      </motion.div>
    </div>
  );
}
